// bao migrate skip
import "./grid-module";
import * as ko from "knockout";
import * as $ from "jquery";
export interface GridComponentParams {
    dataSource: KnockoutObservableArray<any>;
    columns: GridColumn[];
    editing: Editing;
    showBorders?: boolean;
    allowColumnReordering?: boolean;
    allowColumnResizing?: boolean;
    groupPanel: {
        visible?: boolean,
    };
}
export interface GridColumn {
    caption: string;
    dataField: string;
    dataType?: string;
    witdth?: number;
    visible?: boolean;
    fixed?: boolean;
}
export interface Editing {
    mode: "cell" | "form" | "row";
    allowUpdating?: boolean;
    allowDeleting?: boolean;
    allowAdding?: boolean;
}
export class GridComponent {
    dataSourceObservable;
    dataGridOptions: any;
    GridHTML: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    constructor(params: {
        gridData: GridComponentParams;
    }, componentElement: HTMLElement) {
        if (!params) {
            throw new Error('Params are not set');
        }
        this.dataSourceObservable = params.gridData.dataSource;
        this.dataGridOptions = params.gridData;
        this.dataGridOptions.dataSource = params.gridData.dataSource();
        this.dataGridOptions.onRowUpdated = (e) => this.onDataChange(e);
        this.dataGridOptions.onRowRemoving = (e) => this.onDataChange(e);
        this.dataGridOptions.groupPanel.visible = true;
        $(this.GridHTML()).dxDataGrid(this.dataGridOptions);
    }
    onDataChange(e) {
        this.dataSourceObservable(this.dataGridOptions.dataSource);
    }
}